import script from "./Warranty.vue?vue&type=script&setup=true&lang=ts"
export * from "./Warranty.vue?vue&type=script&setup=true&lang=ts"

export default script